import * as BABYLON from '@babylonjs/core/Legacy/legacy';

const log = console.log.bind(console)


class Actions {
    // 表示是否在跑步
    public run: boolean = false;
    // 是否在跳跃
    public jump: boolean = false;

    constructor() {
    }
}


export class ActionData {
    // 移动的速度
    public speed: number;
    private ag: BABYLON.AnimationGroup;
    private loop: boolean = true;
    private rate: number = 1;

    public constructor(speed: number, ag: BABYLON.AnimationGroup, rate: number) {
        this.speed = speed;
        this.ag = ag;
        this.rate = rate;
    }

    public start() {
        this.ag.start(this.loop, this.rate);
    }

    public stop() {
        this.ag.stop();
    }
}


class Animations {
    public run: ActionData;
    public jump: ActionData;
}


export class KinematicObject {
    private scene: BABYLON.Scene;
    private avatar: BABYLON.Mesh;

        // 状态 是否在跑步或其他
    private act: Actions;
        // 动画
    private actions: Animations;
        // 重力
    private gravity: number = 10;

        // 坡度, 大于 maxSlopeLimit 会爬不上, 小于 minSlopeLimit 会当平面继续走
    private minSlopeLimit: number = 1;
    private sl1: number = Math.PI * this.minSlopeLimit / 180;

        // 用来控制掉落多少帧情况下 才启动掉落的动画; 这里用不上
    private fallFrameCountMin: number = 50;
    private fallFrameCount: number = 0;

        // 如果模型加载出来 面朝 +z 说明就是 frontFace true
        // movePOV 是按照模型的正面方向来移动 所以这里是控制移动的正负方向
    private ffSign: number = 1;

        // 计算出来的每帧位移向量
    private moveVector: BABYLON.Vector3;
        // 记录每帧开始时的位置
    private avStartPos: BABYLON.Vector3;
        // 记录刚开始爬坡的位置
    private vMovStartPos: BABYLON.Vector3 = BABYLON.Vector3.Zero();

    private inFreeFall: boolean = false;
    private grounded: boolean = false;
    private idleFallTime: number = 0;
        // 移动过程 fall 经历的时长, 用来控制重力对移动的影响
    private movFallTime: number = 0;

        // 横向移动的方向
    private moveRight: boolean = false;
    private moveLeft: boolean = false;
        // 轴
    private toX: boolean = false;
    private toZ: boolean = false;
        // 横向移动的目标
    private destX: number;
    private destZ: number;
        // 横向移动的速度
    private horiSpeed: number = 0.01;

        // 起跳时的位置
    private jumpStartPosY: number = 0;
        // 跳跃累计的时间
    private jumpTime: number = 0;
        // 自由落体重力影响的位移
    private freeFallDist: number = 0;

        // 模型的位置
    public position: BABYLON.Vector3;
        // 上一个动画
    private prevActData: ActionData = null;

    constructor(scene: BABYLON.Scene, avatar: BABYLON.Mesh, animationMap: {}, runSpeed: number, jumpSpeed: number) {
        this.scene = scene
        this.avatar = avatar
        this.act = new Actions();
        this.position = this.avatar.position
        this.moveVector = new BABYLON.Vector3(0, 0, 0)
        this.avStartPos = BABYLON.Vector3.Zero()

        // 设置对应动作的动画
        this.actions = new Animations()
        this.actions.run = new ActionData(runSpeed, animationMap['run'], 1)
        this.actions.jump = new ActionData(jumpSpeed, animationMap['jump'], 1)
    }

    public setRunSpeed(speed: number) {
        this.actions.run.speed = speed
    }

    public getRunSpeed(): number {
        return this.actions.run.speed
    }

    public run() {
        this.act.run = true;
    }

    public jump() {
        this.act.jump = true;
    }

    public anyMovement(): boolean {
        return this.act.run;
    }

    private endFreeFall(): void {
        // log('endFreeFall')
        this.movFallTime = 0;
        this.fallFrameCount = 0;
        this.inFreeFall = false;
    }

    // 检查一定误差内 两个向量长度是否相等
    private areVectorsEqual(v1: BABYLON.Vector3, v2: BABYLON.Vector3, p: number) {
        return ((Math.abs(v1.x - v2.x) < p) && (Math.abs(v1.y - v2.y) < p) && (Math.abs(v1.z - v2.z) < p));
    }

    private numberEqual(n1: number, n2: number, p: number) {
        return (Math.abs(n1 - n2) < p);
    }

    // 计算坡度
    private verticalSlope(v: BABYLON.Vector3): number {
        return Math.atan(Math.abs(v.y / Math.sqrt(v.x * v.x + v.z * v.z)));
    }

    // 计算当前帧 跳跃产生的垂直位移
    private calcJumpDist(speed: number, dt: number): number {
        // 自由落体公式能够推导出
        //up velocity at the begining of the lastt frame (v=u+at)
        let js: number = speed - this.gravity * this.jumpTime;
        //distance travelled up since last frame to this frame (s=ut+1/2*at^2)
        let jumpDist: number = js * dt - 0.5 * this.gravity * dt * dt;
        return jumpDist;
    }

    private doMove(dt: number): ActionData {
        let self = this;

        // 这一段是自由落体公式 假设是自由落体的情况下这一帧应该产生的垂直位移
        const u: number = this.movFallTime * this.gravity
        this.freeFallDist = u * dt + this.gravity * dt * dt / 2;

        this.movFallTime = this.movFallTime + dt;
        let actdata: ActionData = this.actions.run;
        if (this.inFreeFall) {
            this.moveVector.y = -this.freeFallDist;
        }

        // 非自由落体的情况下 计算水平的位移
        if (!this.inFreeFall) {
            let horizDist: number = 0;

            // 这一大段 switch 里面这有这个分支需要看
            // 水平位移 前进
            horizDist = this.actions.run.speed * dt;
            actdata = this.actions.run;

            
            let rightDist = 0
            if (this.moveLeft || this.moveRight) {
                rightDist = this.horiSpeed
                let destVal = this.destX
                let curVal = this.position.x
                if (this.toZ) {
                    destVal = this.destZ
                    curVal = this.position.z
                }
                if (this.numberEqual(destVal, curVal, this.horiSpeed)) {
                    rightDist = Math.abs(destVal - curVal)
                }
                if (this.moveLeft) {
                    rightDist = -rightDist
                }
                if (this.numberEqual(destVal, curVal, this.horiSpeed)) {
                    this.resetMoveHori()
                }
            }
            
            // movePOV 就是说以 mesh 的视角看 向它自己的前后左右上下移动
            this.moveVector = this.avatar.calcMovePOV(rightDist, -this.freeFallDist, this.ffSign * horizDist);
        }

        // move the avatar
        if (this.moveVector.length() <= 0.001) {
            return actdata
        }

        // moveWithCollisions 使用碰撞引擎来做移动  移动后的位移是根据是否碰撞决定的
        this.avatar.moveWithCollisions(this.moveVector);

        // 通过 y 变大判断出是上坡
        if (this.avatar.position.y > this.avStartPos.y) {
            // log('上坡')
            // actDisp 就是实际的位移
            const actDisp: BABYLON.Vector3 = self.avatar.position.subtract(self.avStartPos);
            // 通过实际的位移计算坡度
            const _slp: number = self.verticalSlope(actDisp);
            if (_slp > self.sl1) {
                // 除了 _movFallTime 其他都重置
                // moveFallTIme 继续增大 有减缓上坡速度的作用
                self.fallFrameCount = 0;
                self.inFreeFall = false;
            } else {
                // 微小坡 先当做平地继续走
                // continue walking
                // log('上坡 freeFall', this.movFallTime, this.avStartPos.y)
                self.endFreeFall();
            }

        } else if ((this.avatar.position.y) < this.avStartPos.y) {
            // 下坡, 计算实际位移
            const actDisp: BABYLON.Vector3 = this.avatar.position.subtract(this.avStartPos);
            // 如果坡度小 继续保持走 否则下滑
            if (this.verticalSlope(actDisp) <= this.sl1) {
                // log('下坡 freeFall', this.verticalSlope(actDisp) / Math.PI * 180)
                this.endFreeFall();
            } else {
                // 下滑就是让 moveFallTIme 继续变大 增加重力的位移影响
                this.fallFrameCount = 0;
                this.inFreeFall = false;
            }
            
        } else {
            this.endFreeFall();
        }

        return actdata;
    }


    private endJump() {
        this.act.jump = false;
        this.jumpTime = 0;
    }

    private doJump(dt: number): ActionData {
        let actData: ActionData = null;
        actData = this.actions.jump;
        // 记录起跳的高度
        if (this.jumpTime === 0) {
            this.jumpStartPosY = this.avatar.position.y;
        }
        // 记录跳的累计时间
        this.jumpTime = this.jumpTime + dt;

        let forwardDist: number = 0;
        let jumpDist: number = 0;
        let disp: BABYLON.Vector3;

        // 跑动状态下的跳跃 需要考虑水平位移
        forwardDist = this.actions.run.speed * dt;
        // 跳跃之前跑动的位移向量
        disp = this.moveVector.clone();
        disp.y = 0;
        disp = disp.normalize();
        disp.scaleToRef(forwardDist, disp);
        // 水平位移不变 额外叠加垂直方向的位移
        jumpDist = this.calcJumpDist(this.actions.jump.speed, dt);
        disp.y = jumpDist;

        this.avatar.moveWithCollisions(disp);
        if (jumpDist < 0) {
            // this.avStartPos 是这一帧开始时的位置
            // 所以 this.avatar.position.y > this.avStartPos.y 表示本该 小于 结果 大于，说明下降过程发生了碰撞，是完成掉落的意思
            if ((this.avatar.position.y > this.avStartPos.y) || ((this.avatar.position.y === this.avStartPos.y) && (disp.length() > 0.001))) {
                this.endJump();
            } else if (this.avatar.position.y < this.jumpStartPosY) {
                // 当前位置比原本起跳的高度还要低 说明在继续下落
                // 当前位置和这帧开始的初始位置做相减 得到这帧的实际位移 actDisp
                const actDisp: BABYLON.Vector3 = this.avatar.position.subtract(this.avStartPos);
                if (!(this.areVectorsEqual(actDisp, disp, 0.001))) {
                    // 实际位移和理论位移相差过大 说明是落在下坡上
                    if (this.verticalSlope(actDisp) <= this.sl1) {
                        this.endJump();
                    }
                } else {
                    // 如果实际位移 actDisp 和理论位移 disp 相等 说明是自由落体
                    actData = this.actions.run;
                }
            }
        }
        return actData;
    }

    moveLeftToX(x: number) {
        this.toX = true
        this.destX = x
        this.moveLeft = true;
    }

    moveRightToX(x: number) {
        this.toX = true
        this.destX = x
        this.moveRight = true;
    }

    moveLeftToZ(z: number) {
        this.toZ = true
        this.destZ = z
        this.moveLeft = true;
    }

    moveRightToZ(z: number) {
        this.toZ = true
        this.destZ = z
        this.moveRight = true;
    }

    resetMoveHori() {
        this.toX = false
        this.toZ = false
        this.moveLeft = false
        this.moveRight = false
    }

    isMovingHori() {
        return this.toX || this.toZ || this.moveLeft || this.moveRight
    }

    public update() {
        // 复制当前任务的位置 作为后续的参考
        this.avStartPos.copyFrom(this.avatar.position);

        let actData: ActionData = null;
        const dt: number = this.scene.getEngine().getDeltaTime() / 1000;

        if (this.act.jump) {
            this.grounded = false;
            this.idleFallTime = 0;
            actData = this.doJump(dt);
        } else if (this.anyMovement() || this.inFreeFall) {
            this.grounded = false;
            this.idleFallTime = 0;
            actData = this.doMove(dt);
        } else {
            // log('没有动画')
        }

        // 这里处理动画
        if (this.prevActData !== actData) {
            if (this.prevActData !== null) {
                this.prevActData.stop();
            }
            actData.start();

            this.prevActData = actData;
        }

        return;
    }

}